<template>
  <section class="modal party" v-if="getParty" @click="changeState('party')">

    <div class="modal-block" @click.prevent.stop>
        <div class="party-header">
            <h4 class="party-title" v-if="getPartyUsers">{{ getPartyUsers.length }} участников</h4>
            <div class="party-add" v-if="userCanAdd" @click="$store.dispatch('changeState', {element:'invite'})">
                <img src="@/assets/images/icons/icon_plus.svg">
                <p>Пригласить</p>
            </div>
        </div>
        <div class="party-body" v-if="getPartyUsers">
            <router-link :to="'/user/'+ user.id" class="party-user" v-for="user of getPartyUsers" :key="user.id" >
                <div class="party-user__avatar" :style="{ backgroundImage: 'url(' + user.avatar + ')' }"></div>
                <p class="party-user__name">{{ user.firstname + ' ' + user.lastname }}</p>
            </router-link>
        </div>
    </div>
  </section>
</template>
<script>

export default {
  name: "ModalEvent",
  data: () => {
    return {
    };
  },
  computed: {
      getParty() {
          return this.$store.getters.party
      },
      getPartyUsers() {
          return this.$store.getters.getPartyUsers
      },
      userCanAdd () {
        return this.$store.getters.userCanAdd
      }
  },
  methods: {
    changeState (element) {
        this.$store.dispatch('changeState', {element})
    }
  }
};
</script>